import Vue from 'vue'
import Amplify from 'aws-amplify'

import App from './App.vue'
import Router from 'vue-router'
import awsExports from './aws-exports'
import { getEnv } from './utils'
import config from './config'

if (typeof window.newrelic === 'object') {
  window.newrelic.setCustomAttribute('appType', `SOF ${config.appName}`)
  window.newrelic.setCustomAttribute('appVersion', config.appVersion)
  window.newrelic.setCustomAttribute('environment', (getEnv() === 'development' ? 'dev' : 'prod'))
}

Vue.use(Router)

const router =  new Router({
  mode: 'history',
  hash: false,
  routes: [
    {
      path: '/:orderNumber',
      name: 'tracker',
      component: () => import(/* webpackChunkName: "tracker" */ './views/Tracker.vue'),
      props: { retailerId: 'SOF' }
    }
  ]
});

Amplify.configure(awsExports);
Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
